export const getContainerStyles = (currentTheme, isRTL) => ({
  minHeight: "100vh",
  background: currentTheme?.background?.gradient || "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  fontFamily: isRTL
    ? "'Cairo', 'Tajawal', " + (currentTheme?.fonts?.primary || "Arial, sans-serif")
    : currentTheme?.fonts?.primary || "Arial, sans-serif",
  position: "relative",
  overflow: "hidden",
  transition: "all 0.3s ease",
  direction: isRTL ? "rtl" : "ltr",
});

export const getBackgroundOverlayStyles = (currentTheme) =>
  currentTheme?.background?.overlay || {};

export const getDecorativeContainerStyles = (currentTheme) =>
  currentTheme?.background?.decorative?.container || {};

export const getCircleStyles = (currentTheme, isRTL) => {
  const circle1Styles = {
    ...(currentTheme?.background?.decorative?.circle1 || {}),
    [isRTL ? 'left' : 'right']: currentTheme?.background?.decorative?.circle1?.right || '0',
  };
  const circle2Styles = {
    ...(currentTheme?.background?.decorative?.circle2 || {}),
    [isRTL ? 'right' : 'left']: currentTheme?.background?.decorative?.circle2?.left || '0',
  };
  return { circle1Styles, circle2Styles };
};

export const getGlobalStyles = (isRTL, currentTheme, isDarkMode, sidebarOpen) => `
  @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;900&family=Tajawal:wght@400;500;700;800&display=swap');
  
  * { 
    box-sizing: border-box;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  
  *::-webkit-scrollbar {
    display: none;
  }
  
  body {
    margin: 0;
    padding: 0;
    font-family: ${isRTL ? "'Cairo', 'Tajawal', " : ""}${currentTheme?.fonts?.primary || "Arial, sans-serif"};
    direction: ${isRTL ? 'rtl' : 'ltr'};
    overflow-x: hidden;
  }
  
  input, textarea, select {
    font-family: inherit;
    direction: ${isRTL ? 'rtl' : 'ltr'};
    text-align: ${isRTL ? 'right' : 'left'};
  }
  
  input::placeholder { 
    color: ${currentTheme?.colors?.textSecondary || "#666"}; 
    text-align: ${isRTL ? 'right' : 'left'};
  }
  
  /* RTL Support - دعم كامل للسايد بار */
  .mo3ti-sidebar {
    position: fixed;
    top: 0;
    ${isRTL ? 'right: 0; left: auto;' : 'left: 0; right: auto;'}
    height: 100vh;
    width: 280px;
    transition: all 0.3s ease;
    z-index: 100;
  }
  
  .mo3ti-main {
    ${isRTL ? 'margin-right: 280px; margin-left: 0;' : 'margin-left: 280px; margin-right: 0;'}
    transition: all 0.3s ease;
    min-height: 100vh;
  }
  
  .mo3ti-content {
    direction: ${isRTL ? 'rtl' : 'ltr'};
    text-align: ${isRTL ? 'right' : 'left'};
  }
  
  /* تحسين عرض النصوص والأيقونات في السايد بار */
  .mo3ti-sidebar .nav-item {
    display: flex;
    align-items: center;
    ${isRTL ? 'flex-direction: row-reverse;' : 'flex-direction: row;'}
    justify-content: ${isRTL ? 'flex-end' : 'flex-start'};
    gap: 12px;
    padding: 12px 16px;
    border-radius: 12px;
    transition: all 0.3s ease;
    text-align: ${isRTL ? 'right' : 'left'};
  }
  
  .mo3ti-sidebar .nav-item-text {
    flex: 1;
    text-align: ${isRTL ? 'right' : 'left'};
    direction: ${isRTL ? 'rtl' : 'ltr'};
  }
  
  .mo3ti-sidebar .nav-icon {
    flex-shrink: 0;
  }
  
  /* تحسين التوب بار */
  .mo3ti-topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${isRTL ? 'flex-direction: row-reverse;' : 'flex-direction: row;'}
  }
  
  .mo3ti-topbar-actions {
    display: flex;
    align-items: center;
    ${isRTL ? 'flex-direction: row-reverse;' : 'flex-direction: row;'}
    gap: 12px;
  }
  
  .mo3ti-switch-button {
    display: flex;
    align-items: center;
    ${isRTL ? 'flex-direction: row-reverse;' : 'flex-direction: row;'}
    gap: 8px;
    padding: 8px 16px;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .mo3ti-user-info {
    display: flex;
    align-items: center;
    ${isRTL ? 'flex-direction: row-reverse;' : 'flex-direction: row;'}
    gap: 12px;
  }
  
  .mo3ti-user-details {
    text-align: ${isRTL ? 'right' : 'left'};
    direction: ${isRTL ? 'rtl' : 'ltr'};
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .mo3ti-sidebar { 
      width: 100% !important; 
      ${isRTL ? 'right' : 'left'}: ${sidebarOpen ? "0" : "-100%"} !important; 
      ${isRTL ? 'left' : 'right'}: auto !important;
      z-index: 1000;
    }
    
    .mo3ti-main { 
      ${isRTL ? 'margin-right' : 'margin-left'}: 0 !important; 
      ${isRTL ? 'margin-left' : 'margin-right'}: 0 !important;
    }
    
    .mo3ti-topbar { 
      padding: 12px 16px !important; 
    }
    
    .mo3ti-content { 
      padding: 20px 16px !important; 
    }
    
    .mo3ti-search { 
      width: 200px !important; 
    }
  }
  
  @media (max-width: 480px) {
    .mo3ti-content { 
      padding: 16px 12px !important; 
    }
    
    .mo3ti-search { 
      width: 150px !important; 
    }
  }
  
  /* Animations */
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  .fade-in {
    animation: fadeIn 0.3s ease-in-out;
  }
  
  /* Card Styles */
  .mo3ti-card {
    background: ${isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(255,255,255,0.95)'};
    backdrop-filter: blur(10px);
    border-radius: 16px;
    padding: 24px;
    margin-bottom: 20px;
    border: 1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)'};
    transition: all 0.3s ease;
    direction: ${isRTL ? 'rtl' : 'ltr'};
    text-align: ${isRTL ? 'right' : 'left'};
  }
  
  .mo3ti-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px ${isDarkMode ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.1)'};
  }
  
  /* Icon + Text Wrapper */
  .icon-text-wrapper {
    display: flex;
    align-items: center;
    ${isRTL ? 'flex-direction: row-reverse;' : 'flex-direction: row;'}
    gap: 8px;
  }
  
  /* Button Groups */
  .button-group {
    display: flex;
    ${isRTL ? 'flex-direction: row-reverse;' : 'flex-direction: row;'}
    gap: 12px;
    align-items: center;
  }
`;
